(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bene-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
    class BenePdpIngredients extends HTMLElement {
        constructor() {
            super();

            this.sidebar = this.querySelector('[data-sidebar]');
            this.expandedTab = this.querySelector('[data-expanded-tab]');
            this.close = this.querySelector('[data-close]');

            this.slideCards = this.querySelectorAll('[data-slide-card]');
            this.expandedCards = this.querySelectorAll('[data-expanded-card]');

            this.initSidebar();
        }

        initSidebar() {
            this.slideCards.forEach((card, index) => {
                card.addEventListener('click', () => {
                    console.log('Card clicked:', index);
                    this.sidebar.toggleAttribute('data-active');
                    document.body.style.overflow = 'hidden'; // Prevent scrolling when sidebar is open
                    setTimeout(() => {
                        this.expandedTab.toggleAttribute('data-active');
                        this.expandedCards[index].toggleAttribute(
                            'data-active',
                        );
                    }, 200);
                });
            });

            this.close?.addEventListener('click', () => {
                this.closeSidebar();
            });

            this.sidebar?.addEventListener('click', (event) => {
                if (event.target === this.sidebar) {
                    this.closeSidebar();
                }
            });
        }

        closeSidebar() {
            this.sidebar.removeAttribute('data-active');
            this.expandedTab.removeAttribute('data-active');
            this.expandedCards.forEach((card) =>
                card.removeAttribute('data-active'),
            );
            document.body.style.overflow = ''; // Restore scrolling when sidebar is closed
        }
    }

    customElements.define('bene-pdp-ingredients', BenePdpIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bene-product-page"] && !Shopify.designMode) return;
  try {
    
  class BeneProductPage extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.bene-product-page') || document;
      const options = this.querySelectorAll('[data-price-option]');

      options.forEach((option) => {
        option.addEventListener('click', () => {
          options.forEach((el) => el.classList.remove('bpp-price-option--active'));
          option.classList.add('bpp-price-option--active');

          const input = option.querySelector('input');
          if (input) input.checked = true;

          const labelText = option.querySelector('.bpp-price-option__label').textContent.trim();
          const priceText = option.querySelector('.bpp-price-option__price').childNodes[0].textContent.trim();
          const perDayEl = option.querySelector('.bpp-price-option__per-day');
          const perDayText = perDayEl ? perDayEl.textContent.trim() : '';

          const atcLabel = root.querySelector('[data-atc-label]');
          if (atcLabel) atcLabel.textContent = 'ADD TO CART — ' + priceText;

          const stickyLabel = root.querySelector('[data-sticky-atc-label]');
          if (stickyLabel) stickyLabel.textContent = 'ADD TO CART — ' + priceText;

          const stickySub = root.querySelector('[data-sticky-sub]');
          if (stickySub) {
            const base = labelText.indexOf('Subscribe') === 0 ? 'Subscribe & save 15%' : 'One-time purchase';
            stickySub.textContent = perDayText ? base + ' · ' + perDayText : base;
          }
        });
      });
    }
  }
  customElements.define('bene-purchase-option', BeneProductPage);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bene-product-page').forEach(function (root) {
      const qtyValue = root.querySelector('[data-qty-value]');
      const minusBtn = root.querySelector('[data-qty-minus]');
      const plusBtn = root.querySelector('[data-qty-plus]');

      if (qtyValue && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', function () {
          const current = parseInt(qtyValue.textContent, 10) || 1;
          qtyValue.textContent = Math.max(1, current - 1);
        });
        plusBtn.addEventListener('click', function () {
          const current = parseInt(qtyValue.textContent, 10) || 1;
          qtyValue.textContent = current + 1;
        });
      }

      const mainAtc = root.querySelector('[data-bpp-main-atc]');
      const stickyBar = root.querySelector('[data-bpp-sticky-atc]');

      if (mainAtc && stickyBar && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              stickyBar.hidden = entry.isIntersecting;
            });
          },
          { threshold: 0 }
        );
        observer.observe(mainAtc);
      }

      const stickyBtn = root.querySelector('[data-bpp-sticky-btn]');
      if (stickyBtn && mainAtc) {
        stickyBtn.addEventListener('click', function () {
          mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bene-testimonial"] && !Shopify.designMode) return;
  try {
    
  class BeneTestimonialContent extends HTMLElement {
    constructor() {
      super();

      this.content = this.querySelector('.testimonial-card__description');
      this.button = this.querySelector('button');

      this.button.addEventListener('click', () => {
        const contentShown = this.dataset.expanded === 'true';
        this.setAttribute('data-expanded', contentShown ? 'false' : 'true');
      });
    }
  }
  customElements.define('bene-testimonial-content', BeneTestimonialContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cw-doctors"] && !Shopify.designMode) return;
  try {
    
  class BeneTestimonialContent extends HTMLElement {
    constructor() {
      super();
      
      console.log("HERE")

      this.content = this.querySelector('.testimonial-card__description');
      this.button = this.querySelector('button');

      this.button.addEventListener('click', () => {
        const contentShown = this.dataset.expanded === 'true';
        this.setAttribute('data-expanded', contentShown ? 'false' : 'true');
      });
    }
  }
  customElements.define('bene-testimonial-content', BeneTestimonialContent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-switcher"] && !Shopify.designMode) return;
  try {
    
  /**
   * StoreSwitcher - Custom HTML Element
   *
   * Handles the behavior of the store switcher popup including:
   * - Geo-location detection
   * - Conditional visibility based on user location and domain
   * - One-time display with localStorage persistence
   * - Smart redirection only when needed
   */
  class StoreSwitcher extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.shouldShow = JSON.parse(this.getAttribute('data-should-show') || 'false');
      this.devMode = JSON.parse(this.getAttribute('data-dev-mode') || 'false');
      this.currentDomain = window.location.hostname;

      this.attachEventListeners();
      // Check visibility after a small delay to ensure DOM is fully ready
      setTimeout(() => this.checkVisibility(), 10);
    }

    async getUserCountry() {
      try {
        const response = await fetch("https://ipinfo.io/json?token=c86425d56ba631");
        const data = await response.json();
        return data.country || '';
      } catch (error) {
        console.error('Error fetching location:', error);
        return null;
      }
    }

    attachEventListeners() {
      const closeButton = this.querySelector('.store-switcher__close-button');
      const overlay = this.querySelector('.store-switcher__overlay');
      const storeButtons = this.querySelectorAll('.store-switcher__button');

      if (closeButton) {
        closeButton.addEventListener('click', () => this.close());
      }

      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      if (storeButtons) {
        storeButtons.forEach(button => {
          button.addEventListener('click', (e) => {
            e.preventDefault();

            const targetDomain = button.getAttribute('data-store-domain');
            const storeType = button.getAttribute('data-store-type');
            const currentDomain = window.location.hostname;

            // Only redirect if the user is on a different domain than the one they selected
            if ((storeType === 'ch' && !currentDomain.includes('beneganic.ch')) ||
                (storeType === 'eu' && !currentDomain.includes('beneganic.com'))) {
              window.location.href = targetDomain;
            } else {
              // Just close the popup if they're already on the right domain
              this.close();
            }
          });
        });
      }
    }

    close() {
      this.classList.remove('active');
      // Mark that the user has seen the popup
      localStorage.setItem('store_switcher_opened', 'true');
    }

    async checkVisibility() {
      // In dev mode, always show the popup
      if (this.devMode) {
        this.classList.add('active');
        return;
      }

      // Check if the modal should be shown based on localStorage
      const hasOpenedBefore = localStorage.getItem('store_switcher_opened') === 'true';

      // Don't show if it's been opened before
      if (hasOpenedBefore) {
        this.classList.remove('active');
        return;
      }

      // Check user's country
      const userCountry = await this.getUserCountry();
      if(userCountry == null) {
        return;
      }
      const isUserInSwitzerland = userCountry === 'CH';

      // Determine if we should show the popup based on domain and location
      let shouldShowBasedOnGeo = false;

      if (this.currentDomain.includes('beneganic.com') && isUserInSwitzerland) {
        // Case A: User is on .com but is in Switzerland
        shouldShowBasedOnGeo = true;
      } else if (this.currentDomain.includes('beneganic.ch') && !isUserInSwitzerland) {
        // Case B: User is on .ch but is not in Switzerland
        shouldShowBasedOnGeo = true;
      }

      // Show the modal if geo conditions are met and it's enabled in settings
      if (shouldShowBasedOnGeo && this.shouldShow) {
        this.classList.add('active');
        // Mark that we've shown the popup to this user
        localStorage.setItem('store_switcher_opened', 'true');
      } else {
        this.classList.remove('active');
      }
    }

    // Add a public method to open the popup manually if needed
    open() {
      this.classList.add('active');
    }

    // Add a method to reset the popup state (for testing)
    reset() {
      localStorage.removeItem('store_switcher_opened');
      this.checkVisibility();
    }
  }

  // Define the custom element
  if (!customElements.get('store-switcher')) {
    customElements.define('store-switcher', StoreSwitcher);
  }

// Make the store-switcher element accessible globally
window.storeSwitcherAPI = {
  open: function() {
    const storeSwitcher = document.getElementById('store-switcher');
    if (storeSwitcher) {
      storeSwitcher.open();
    }
  },
  reset: function() {
    const storeSwitcher = document.getElementById('store-switcher');
    if (storeSwitcher) {
      storeSwitcher.reset();
    }
  }
};

  } catch(e) { console.error(e); }
})();
})();
